export const APPEND_DICTIONARY_MODAL_ID = 'modal-id/append-dictionary';
export const AI_VIDEO_LABEL_MODAL_ID = 'modal-id/ai-video-label';
export const EXIT_MODAL_ID = 'modal-id/exit';
export const PREVIEW_MODAL_ID = 'modal-id/preview';
export const RENAME_MODAL_ID = 'modal-id/rename';
export const DELETE_FLOW_MODAL_ID = 'modal-id/delete-flow';
export const UNPUBLISH_FLOW_MODAL_ID = 'modal-id/unpublish-flow';
export const DUPLICATE_FLOW_MODAL_ID = 'modal-id/duplicate-flow';
export const PLAYER_TYPE_MODAL_ID = 'modal-id/player-type';
export const PREFLIGHT_CHECKS_MODAL_ID = 'modal-id/preflight-checks';
export const PREFLIGHT_FAILURE_MODAL_ID = 'modal-id/preflight-failure';
export const CONFIRM_PASSWORD_MODAL_ID = 'modal-id/confirm-password';
export const CREATE_REEL_MODAL_ID = 'modal-id/create-reel';
export const TRIAL_EXTEND_MODAL_ID = 'modal-id/trial-extend';
export const SUBSCRIPTION_CANCELED_MODAL_ID = 'modal-id/subscription-canceled';
export const PAUSED_FLOWS_MODAL_ID = 'modal-id/paused-flows';
export const MAX_FLOWS_PUBLISHED_MODAL_ID = 'modal-id/max-flows-published';
export const DISMISS_GET_STARTED_CHECKLIST_MODAL_ID =
    'modal-id/dismiss-get-started-checklist';
export const RESET_PLAYER_DIMENSIONS_MODAL_ID =
    'modal-id/reset-player-dimensions';
export const IMPORT_TEMPLATE_MODAL_ID = 'modal-id/import-template';

export const modalIds = [
    APPEND_DICTIONARY_MODAL_ID,
    AI_VIDEO_LABEL_MODAL_ID,
    EXIT_MODAL_ID,
    PREVIEW_MODAL_ID,
    RENAME_MODAL_ID,
    DELETE_FLOW_MODAL_ID,
    UNPUBLISH_FLOW_MODAL_ID,
    DUPLICATE_FLOW_MODAL_ID,
    PLAYER_TYPE_MODAL_ID,
    PREFLIGHT_CHECKS_MODAL_ID,
    PREFLIGHT_FAILURE_MODAL_ID,
    CONFIRM_PASSWORD_MODAL_ID,
    CREATE_REEL_MODAL_ID,
    TRIAL_EXTEND_MODAL_ID,
    DISMISS_GET_STARTED_CHECKLIST_MODAL_ID,
    PAUSED_FLOWS_MODAL_ID,
    MAX_FLOWS_PUBLISHED_MODAL_ID,
    SUBSCRIPTION_CANCELED_MODAL_ID,
    RESET_PLAYER_DIMENSIONS_MODAL_ID,
    IMPORT_TEMPLATE_MODAL_ID,
] as const;

export type ModalId = (typeof modalIds)[number];

export type AppModalProps<T = undefined> = {
    payload: T;
    onClose: () => void;
};
